<template>
  <div>
    <v-text-field
      label="First Name"
      v-model="student.first_name"
    ></v-text-field>
    <v-text-field label="Last Name" v-model="student.last_name"></v-text-field>
    <v-text-field
      label="Parent/Guardian Name"
      v-model="student.parent_name"
    ></v-text-field>

    <!-- in date start -->
    <v-menu
      class="pr-2"
      ref="statDate"
      lazy
      :close-on-content-click="false"
      v-model="startDateMenu"
      transition="scale-transition"
      offset-y
      full-width
      :nudge-bottom="-22"
      max-width="290px"
      :return-value.sync="inDate"
    >
      <v-text-field
        slot="activator"
        v-model="inDate"
        label="In Date"
        append-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker
        v-model="inDate"
        no-title
        scrollable
        @change="changeFromDate(inDate)"
      >
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="startDateMenu = false"
          >Cancel</v-btn
        >
        <v-btn flat color="primary" @click="$refs.statDate.save(inDate)"
          >OK</v-btn
        >
      </v-date-picker>
    </v-menu>
    <!-- in date end -->

    <!-- in time start -->
    <v-menu
      ref="menu"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="inTime"
          label="In Time"
          prepend-icon="access_time"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu2"
        v-model="inTime"
        full-width
        @click:minute="$refs.menu.save(time)"
        @change="changeFromTime(inTime)"
      ></v-time-picker>
    </v-menu>
    <!-- in time end -->

    <!-- out date start -->
    <v-menu
      v-if="outDate"
      class="pr-2"
      ref="statDate"
      lazy
      :close-on-content-click="false"
      v-model="endDateMenu"
      transition="scale-transition"
      offset-y
      full-width
      :nudge-bottom="-22"
      max-width="290px"
      :return-value.sync="outDate"
    >
      <v-text-field
        slot="activator"
        v-model="outDate"
        label="In Date"
        append-icon="event"
        readonly
      ></v-text-field>
      <v-date-picker
        v-model="outDate"
        no-title
        scrollable
        @change="changeFromDate(outDate)"
      >
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="endDateMenu = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="$refs.statDate.save(outDate)"
          >OK</v-btn
        >
      </v-date-picker>
    </v-menu>
    <!-- out date end -->
    <!-- out time start -->
    <v-menu
      v-if="outTime"
      ref="menu"
      v-model="menu3"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      full-width
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="outTime"
          label="Out Time"
          prepend-icon="access_time"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu3"
        v-model="outTime"
        full-width
        @click:minute="$refs.menu.save(time)"
        @change="changeFromTime(outTime)"
      ></v-time-picker>
    </v-menu>
    <!-- out time end -->

    <v-text-field label="Reason" v-model="student.reason"></v-text-field>
    <div style="text-align: right;">
      <v-btn color="info" small type="submit" @click="updateForm()"
        >Submit</v-btn
      >
    </div>
  </div>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
export default {
  components: {},
  mixins: [APIAttendance],
  data() {
    return {
      student: {},

      inDate: "",
      startDateMenu: false,

      outDate: "",
      endDateMenu: false,

      inTime: null,
      menu2: false,

      outTime: null,
      menu3: false
    };
  },
  computed: {
    queriedUrlId() {
      let url = window.location.href.split("view/");
      let url1 = url[1].split("/");
      return url1[0];
    }
  },
  watch: {},
  created() {
    this.restoreFrom();
  },
  methods: {
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.student = this.$route.params.object;

        if (
          this.$route.params.object.sign_in_date &&
          this.$route.params.object.sign_out_date
        ) {
          this.outDate = this.$route.params.object.sign_out_date;
          this.inDate = this.$route.params.object.sign_in_date;
          this.inTime = this.$route.params.object.sign_in_time;
          this.outTime = this.$route.params.object.sign_out_time;
          this.student.reason = this.$route.params.object.sign_in_reason;
        } else if (this.$route.params.object.sign_in_date) {
          this.inDate = this.$route.params.object.sign_in_date;
          this.inTime = this.$route.params.object.sign_in_time;
          this.student.reason = this.$route.params.object.sign_in_reason;
        } else {
          this.outDate = this.$route.params.object.sign_out_date;
          this.outTime = this.$route.params.object.sign_out_time;
          this.student.reason = this.$route.params.object.sign_out_reason;
        }
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlId !== "0"
      ) {
        try {
          let htype = "student";
          let res = await this.geHistoricalListById(this.queriedUrlId, htype);
          this.student = res[0];

          if (res[0].sign_in_date && res[0].sign_out_date) {
            // this.reasonEvent = "In / Out";
            this.outDate = res[0].sign_out_date;
            this.inDate = res[0].sign_in_date;
            this.inTime = res[0].sign_in_time;
            this.outTime = res[0].sign_out_time;
            this.student.reason = res[0].sign_in_reason;
          } else if (res[0].sign_in_date) {
            // this.reasonEvent = "Sign In";
            this.inDate = res[0].sign_in_date;
            this.inTime = res[0].sign_in_time;
            this.student.reason = res[0].sign_in_reason;
          } else {
            // this.reasonEvent = "Sign Out";
            this.outDate = res[0].sign_out_date;
            this.outTime = res[0].sign_out_time;
            this.student.reason = res[0].sign_out_reason;
          }
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    updateForm: async function() {
      try {
        if (this.inDate) {
          this.student.sign_in_date = this.inDate;
          this.student.sign_in_time = this.inTime;
        } else {
          this.student.sign_out_time = this.outTime;
          this.student.sign_out_date = this.outDate;
        }
        await this.putAttendence(this.student);
        this.$toast.success("Record updated successfully.", "Success", {
          position: "topCenter"
        });

        this.$router.push({
          name: "Historical Students"
        });
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
